import { useAuthContext } from "../auth/AuthProvider";

export const useAuth = () => useAuthContext();